/* app/js/src/components/common/audioMixer/audioMixer.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  display: block;
  width: 100%;
  background-color: #eef2f6;
  border: 1px solid #ffffff;
  border-radius: 4px;
  padding: 7px 12px;
  -webkit-box-shadow: 0 0 0 1px #eef2f6;
  -moz-box-shadow: 0 0 0 1px #eef2f6;
  box-shadow: 0 0 0 1px #eef2f6;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
:host .buttons-container {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
}
:host .buttons-container button {
  height: 31px;
  width: 31px;
  border: 1px solid #e1e6eb;
  background-color: #ffffff;
  border-radius: 4px;
}
:host .buttons-container button:last-child {
  margin-top: 5px;
}
:host .sound-indicator-container {
  margin-left: 12px;
  -webkit-flex: 11 0 0;
  -ms-flex: 11 0 0;
  flex: 11 0 0;
}
:host .sound-indicator-container .decibel-row {
  padding-left: 12px;
  font-size: 0.8em;
  color: #879baf;
  margin-bottom: 5px;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  justify-content: space-between;
}
:host .sound-indicator-container .decibel-row i {
  font-style: normal;
}
:host .sound-indicator-container .decibel-bar-row {
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: flex-start;
  justify-content: flex-start;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
:host .sound-indicator-container .decibel-bar-row > span {
  -webkit-flex: 1 0 0;
  -ms-flex: 1 0 0;
  flex: 1 0 0;
  display: block;
  width: 12px;
  color: #879baf;
  font-size: 0.8em;
}
:host .sound-indicator-container .decibel-bar-row > div {
  -webkit-flex: 11 0 0;
  -ms-flex: 11 0 0;
  flex: 11 0 0;
  background-color: #ffffff;
  padding: 5px 4px;
}
:host .sound-indicator-container .decibel-slider-row {
  padding-left: 12px;
  font-size: 0.8em;
  color: #879baf;
  margin-top: 5px;
}
/*# sourceMappingURL=audioMixer.component.css.map */
